import { render, staticRenderFns } from "./PicturePlaceholderIcon.vue?vue&type=template&id=5f0258f3"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0258f3')) {
      api.createRecord('5f0258f3', component.options)
    } else {
      api.reload('5f0258f3', component.options)
    }
    module.hot.accept("./PicturePlaceholderIcon.vue?vue&type=template&id=5f0258f3", function () {
      api.rerender('5f0258f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PicturePlaceholderIcon.vue"
export default component.exports